import axios from "@axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchResponsibleAreas(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("/responsible-areas", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    createResponsibleArea(ctx, { payload }) {
      return new Promise((resolve, reject) => {
        axios
          .post("/responsible-areas", payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateResponsibleArea(ctx, { id, payload }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/responsible-areas/${id}`, payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteResponsibleArea(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/responsible-areas/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
